import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Loader2, LogIn } from "lucide-react";

const QUICK = [
  ["Logistik", "logistik@pusat.co.id"],
  ["Purchasing", "purchasing@pusat.co.id"],
  ["Keuangan", "keuangan@pusat.co.id"],
  ["Sales & Mktg", "sales@pusat.co.id"],
  ["Cabang Semarang", "cabang.semarang@pusat.co.id"],
];

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
    } catch (e2) {
      setErr(apiError(e2.response?.data?.detail) || e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen w-full grid lg:grid-cols-2">
      <div className="hidden lg:block relative bg-[#0a0a0a]">
        <img
          src="https://images.unsplash.com/photo-1531972111231-7482a960e109?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400"
          alt="Kantor"
          className="absolute inset-0 h-full w-full object-cover opacity-40"
        />
        <div className="relative h-full flex flex-col justify-between p-12 text-white">
          <div className="text-xs uppercase tracking-[0.3em] text-white/70">
            Sistem Informasi Terpadu
          </div>
          <div>
            <h1 className="font-display text-4xl lg:text-6xl font-black leading-[0.95]">
              STOCK &amp;<br />DISTRIBUSI<br />
              <span className="text-[#7c74ff]">NASIONAL</span>
            </h1>
            <p className="mt-6 max-w-md text-sm text-white/70">
              Kendali penuh atas stock 3 gudang &amp; 10 cabang, ETA impor, HPP,
              margin, penjualan mingguan, dan proyeksi kebutuhan material.
            </p>
          </div>
          <div className="mono text-[11px] text-white/50">
            v1.0 — Kantor Pusat &amp; Kantor Cabang
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 bg-[#fafafa]">
        <div className="w-full max-w-sm">
          <div className="mono text-[11px] uppercase tracking-widest text-[#525252]">
            Masuk ke akun anda
          </div>
          <h2 className="font-display text-3xl font-extrabold mt-2">Login</h2>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
            <div>
              <label className="text-xs font-semibold uppercase tracking-wide text-[#525252]">
                Email
              </label>
              <input
                data-testid="login-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="nama@pusat.co.id"
                className="mt-1 w-full h-11 px-3 border border-neutral-300 bg-white outline-none focus:ring-2 focus:ring-[#4338CA] focus:border-transparent transition-colors"
              />
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-wide text-[#525252]">
                Password
              </label>
              <input
                data-testid="login-password-input"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="mt-1 w-full h-11 px-3 border border-neutral-300 bg-white outline-none focus:ring-2 focus:ring-[#4338CA] focus:border-transparent transition-colors"
              />
            </div>

            {err && (
              <div
                data-testid="login-error"
                className="border border-[#ff3b30] bg-red-50 text-[#b91c1c] text-sm px-3 py-2"
              >
                {err}
              </div>
            )}

            <button
              data-testid="login-submit-button"
              type="submit"
              disabled={busy}
              className="w-full h-11 bg-[#4338CA] text-white font-semibold text-sm uppercase tracking-wide hover:bg-[#3730A3] transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <LogIn className="h-4 w-4" />}
              Masuk
            </button>
          </form>

          <div className="mt-10 border-t border-neutral-200 pt-5">
            <div className="mono text-[11px] uppercase tracking-widest text-[#525252]">
              Akun demo (password: password123)
            </div>
            <div className="mt-3 flex flex-wrap gap-2">
              {QUICK.map(([label, mail]) => (
                <button
                  key={mail}
                  type="button"
                  data-testid={`quick-login-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  onClick={() => {
                    setEmail(mail);
                    setPassword("password123");
                  }}
                  className="text-xs px-2.5 py-1.5 border border-neutral-800 hover:bg-neutral-900 hover:text-white transition-colors"
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
